module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAYAAAC3g3x9AAAAAXNSR0IArs4c6QAAASZJREFUSA3tlT1PAlEQRfkKFFBYUElsIDQ2GELQAv+Fiv5EKmpKoaCksecJxthZ2NHgueQ9spJld1DpuMlhZ2fuXOAVu5nMPytvzOvhu4Cl0Z9oazL9hHdoJDoZFtIMzMvw5X2VNH8uzcB8bfBsLZbArdlSnAItp5TsOZ1h8vlYpuEMs5ivoWhZ2vGccd8OvRB4S2MEMzgPw8hVXxinKs0XGENHhhBYov6ASxhA6lPFe4Zca/AGyvihO+7moIfBBOogtWDhUS1pNgZ5taPdWN3TDaFa0OJuYDTMMd8bxmyjPp8h9Jn6BhYe1erplzl4AJMU6kCLU9AZCdUhTJ6D9IjbgQJWnl+Hsb9RNFRhr6Den/TEtgO9Vw7+m+zE6opuF3Kx02M2vwHaZTu7mG9XUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/png/sort-down@2x.png
// module id = 99
// module chunks = 0